/** 制約の対象の指定が無い場合もあるので注意 */
export class EditRuleCondition {
  /** 制約の対象（職種） */
  professionCode: string;
  /** 制約の対象（プロジェクトチーム） */
  projectTeamId: number;

  /** 入力不可の制約を追加するかどうか */
  uneditable: boolean;
  /** 入力チェックを追加するかどうか */
  emptyCheck: boolean;
}
